//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { checkCampaign } from '../../service/index'
///import Starry from '../../utils/fx'
  export default {
    data(){
      return {
        campaignName:"",
        d:'',
        h:'',
        m:'',
        s:'',
        delta:0,
        beginTime:0,
      }
    },
    computed:{

    },
    mounted() {
      this.keepLang()
      this.checkCampaign(this.$route.query.cid)
    },
    methods:{
      async checkCampaign(cid){
        const res = await checkCampaign(cid);
        // this.beginTime=1536249600000
        // this.interval  =  setInterval(this.countdown,  1000);
        if(res.status===0){
          this.$router.push({name:'home',params:{id:this.$route.query.cid},query: {cid: this.$route.query.cid,test:1}})
        }else{
          this.campaignName=res.data[2]
          this.beginTime=res.data[1]
          this.delta = new Date().getTime()-res.data[0];
          this.interval  =  setInterval(this.countdown,  1000);
        }
      },
       keepLang() {
        let locale = localStorage.locale;
        this.$i18n.locale = locale === 'en' ? locale : 'zh';
      },
      countdown(){
        var nowtime = new Date();
        var nowYear = nowtime.getFullYear();
        var nowMonth = nowtime.getMonth();
        var nowDate = nowtime.getDate();
        var ts = parseInt((this.beginTime + this.delta - nowtime.getTime()));
        var d = parseInt(ts / 1000 / 60 / 60 / 24, 10);
        var h = parseInt(ts / 1000 / 60 / 60 - d * 24, 10);
        var m = parseInt(ts / 1000 / 60  - d * 24 * 60 - h * 60 , 10);
        var s = parseInt(ts / 1000  - d * 24 * 60 * 60  - h * 60 * 60 - m * 60 , 10);
        this.d = d < 10 ? '0' + d : d;
        this.h = h < 10 ? '0' + h : h;
        this.m = m < 10 ? '0' + m : m;
        this.s = s < 10 ? '0' + s : s;
        if(ts<=0){
          clearInterval(this.interval)
          this.$router.push({name:'home',params:{id:this.$route.query.cid},query: {cid: this.$route.query.cid,test:1}})
        }
      }

    }
  }



// WEBPACK FOOTER //
// ./src/pages/home/Countdown.vue